import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchSessionsReport } from "../api/fetchSessionsReport/fetchSessionsReportApi";
import {
  FetchSessionsReportParams,
  SessionsReportItem,
} from "../api/fetchSessionsReport/types";
import { AppDispatch, AppThunk } from "@/app/store";

interface SessionsReportState {
  items: SessionsReportItem[];
  totalCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: SessionsReportState = {
  items: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const sessionsReportSlice = createSlice({
  name: "sessionsReport",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setReport: (
      state,
      action: PayloadAction<{
        items: SessionsReportItem[];
        totalCount: number;
      }>,
    ) => {
      state.items = action.payload.items;
      state.totalCount = action.payload.totalCount;
    },
  },
});

export const { setLoading, setError, setReport } = sessionsReportSlice.actions;

export const fetchSessionsReportAction =
  (params: FetchSessionsReportParams = {}): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await fetchSessionsReport(params);
      dispatch(
        setReport({
          items: response.data,
          totalCount: response.meta?.totalCount ?? 0,
        }),
      );
    } catch (error) {
      dispatch(
        setError(
          error instanceof Error
            ? error.message
            : "Failed to fetch sessions report",
        ),
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

export default sessionsReportSlice.reducer;
